import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { AppSettings } from '../helpers';

@Injectable()
export class ContentPageService {
    constructor(private http: HttpClient,
        private appSettings: AppSettings) { }

    getPage(id: number) {
        return this.http.get(this.appSettings.ApiBaseUrl + '/api/contentPage?id=' + id);
    }
}



// WEBPACK FOOTER //
// ./src/services/content.page.service.ts